import {
    getBdUserActionType,
    getBdAge,
    getBdGender,
    getBdLifeStage,
    getBdAndroidBrands,
    getBdDevice,
    getBdEducation,
    getBdExcludeTrans,
    getBdIosVersion,
    getBdNet,
    getBdkeywordsExtend,
} from '@/api/baiduConstant'

import CodeInput from '@/components/code-input/CodeInput.vue'
import { TreeSelect } from 'ant-design-vue';
import baiduRegion from './baiduRegion'

export default {
    components: {
        CodeInput,
    },
    props: {
        model: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            labelCol: { span: 5 },
            wrapperCol: { span: 17 },
            medias: [],
            loading: false,
            region_model: "0",//地域展示样式
            region: [],//地域
            place_model: "0",//场所展示样式
            place: '',//地域
            userActionTypes: [],//用户到访类型
            useractiontypeForm: [],
            keywordsExtend: [],//意图词用户行为
            keywordsExtendForm: '0',
            ageForm: [], //年龄
            ages: [],
            sexForm: [],
            sexs: [],
            excludeTransForm: [],
            LifeStages: [],
            AndroidBrands: [],
            Devices: [],
            Education: [],
            ExcludeTrans: [],
            IosVersion: [],
            nets: [],
            netForm: [],
            keywords: [],
            keywords_model: "0",
            baiduRegion: baiduRegion,
            SHOW_PARENT: TreeSelect.SHOW_PARENT,
            value: [],
        }
    },
    created(){
        if(this.model.keywords){
            setTimeout(() => {
                this.keywords = []
            }, 10)
            setTimeout(() => {
                this.keywords = this.model.keywords
            }, 10)
        }
    },
    mounted() {
        if (this.model.place) {
            setTimeout(() => {
                this.place = this.model.place + ','
            }, 10)
        }
        // console.log('进入：',this.model)
        if (this.model.id || this.model.source_type == 2) {
            this.region = this.model.region ? this.model.region : []
            this.place = this.model.place
            this.useractiontypeForm = this.model.useractiontype
            this.sexForm = this.model.sex
            this.excludeTransForm = this.model.exclude_trans
            this.keywords = this.model.keywords ?  this.model.keywords : []
            this.keywordsExtendForm = this.model.keywords_extend
            this.netForm = this.model.net
        } 

        //用户到访类型
        getBdUserActionType().then(res => {
            this.userActionTypes = res.data.list || {}
            if (!this.model.id && !this.model.useractiontype) {
                this.userActionTypes.forEach(item => {
                    this.useractiontypeForm.push(item.id)
                });
            }
        })

        //意图词行为
        getBdkeywordsExtend().then(res => {
            this.keywordsExtend = res.data.list || {}
            if (!this.model.keywords_extend) {
                this.keywordsExtendForm = this.keywordsExtend[0]['id']
            }
        })

        //年龄
        getBdAge().then(res => {
            this.ages = res.data.list || {}
        })

        //性别
        getBdGender().then(res => {
            this.sexs = res.data.list || {}
            if (!this.model.sex) {
                this.sexForm = this.sexs[0]['id']
            }
        })

        //网络
        getBdNet().then(res => {
            this.nets = res.data.list || {}
            if (!this.model.net) {
                this.netForm = this.nets[0]['id']
            }
        })

        //人生阶段
        getBdLifeStage().then(res => {
            this.LifeStages = res.data.list || {}
        })

        //学历
        getBdEducation().then(res => {
            this.Education = res.data.list || {}
        })

        //排除人群
        getBdExcludeTrans().then(res => {
            this.ExcludeTrans = res.data.list || {}
            if (!this.model.exclude_trans) {
                this.excludeTransForm = this.ExcludeTrans[0]['id']
            }
            
        })

        //操作系统
        getBdDevice().then(res => {
            this.Devices = res.data.list || {}
        })

        //ios操作系统
        getBdIosVersion().then(res => {
            this.IosVersion = res.data.list || {}
        })

        //安卓手机品牌
        getBdAndroidBrands().then(res => {
            this.AndroidBrands = res.data.list || {}
        })

        if (this.region.length > 0) {
            this.region_model = "1";
        }
        if (this.place) {
            this.place_model = "1";
        }
        if (this.keywords && this.keywords.length > 0) {
            this.keywords_model = "1";
        }

    },
    methods: {
        getAtpFeedData() {
            this.storeOrUpdate()
        },
        storeOrUpdate() {
            if (this.region_model == 1) {
                this.model.region = this.region;
            } else {
                this.model.region = [];
            }
            if (this.keywords_model == 1) {
                this.model.keywords = this.keywords;
            } else {
                this.model.keywords = [];
            }
            if (this.place_model == 1) {
                this.model.place = this.place;
            } else {
                this.model.place = '';
            }
            this.model.useractiontype = this.useractiontypeForm
            this.model.sex = this.sexForm
            this.model.exclude_trans = this.excludeTransForm
            this.model.net = this.netForm
            this.model.keywords_extend = this.keywordsExtendForm

            if (this.model.device) {
                if (this.model.device.indexOf(1) == -1) {
                    this.model.ios_version = [0]
                }
                if (this.model.device.indexOf(2) == -1) {
                    this.model.android_brands = [0]
                }
            }

            const data = Object.assign({}, this.model)

            this.$emit('update:apt_feed_data',data )
 
        },
        selectRegion(data) {
            this.region = data;
        },
        selectPlace(data) {
            this.place = data.place;
        },
        changeKeywords(keywords) {
            this.keywords = keywords
        },
        singleChange(item,extra) {
            const lastOne = item[item.length - 1];
            if(lastOne == 0){
                item = [0]
            } else {
                if(item.includes(0)){
                    //去除数组内0
                    item = item.filter(val => val!==0)
                }
            }
            this.model[`${extra}`] = item
        }
    }
}
